<template>
  <v-layout row wrap class="createaccount--contact">
    <v-flex sm12>
      <TextInputCommon
        v-model="value.firstName"
        :disabled="disabled"
        :validations="inputValidations.firstName"
        display-name="First Name"
        identifier="firstName" />
    </v-flex>

    <v-flex sm12>
      <TextInputCommon
        v-model="value.lastName"
        :disabled="disabled"
        :validations="inputValidations.lastName"
        display-name="Last Name"
        identifier="lastName" />
    </v-flex>

    <v-flex sm12 v-if="isRealEstateProfessional">
      <TextInputCommon
        v-model="value.company"
        :disabled="disabled"
        :validations="{ ...inputValidations.company, required: true }"
        display-name="Company"
        identifier="company" />
    </v-flex>

    <v-flex md6 sm12>
      <TextInputCommon
        v-model="value.phone"
        :disabled="disabled"
        :validations="{ ...inputValidations.phone, required: true, min: 10 }"
        display-name="Phone Number"
        identifier="phone"
        mask="###-###-####" />
    </v-flex>

    <v-flex md6 sm12>
      <SelectPhoneType
        v-model="value.phoneType"
        :disabled="disabled"
        display-name="Phone Type" />
    </v-flex>
  </v-layout>
</template>

<script>
import { Constants } from '@spectorasoftware/homegauge-vue';

import SelectPhoneType from '@/components/common/SelectPhoneType.vue';
import TextInputCommon from '@/components/common/TextInputCommon.vue';
import PhoneTypes from '@/constants/phone-types';

const { AccountTypes, InputValidations } = Constants;

export default {
  components: {
    SelectPhoneType,
    TextInputCommon,
  },
  inject: ['$validator'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inputValidations: InputValidations,
      phoneItems: [
        { text: PhoneTypes.mobile.display, value: PhoneTypes.mobile.value },
        { text: PhoneTypes.home.display, value: PhoneTypes.home.value },
        { text: PhoneTypes.work.display, value: PhoneTypes.work.value },
      ],
    };
  },
  computed: {
    isRealEstateProfessional() {
      return this.value.type === AccountTypes.REAL_ESTATE_PROFESSIONAL;
    },
  },
};
</script>
